webpackJsonp([51603082022612],{

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(68);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _content = __webpack_require__(22);
	
	var _markdownComponents = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var page = data.page,
	      computerScienceNerdzLogo = data.computerScienceNerdzLogo;
	
	
	  return _react2.default.createElement(
	    _content.Paper,
	    { centered: page.frontmatter.centered },
	    (0, _markdownComponents.renderAst)(page.htmlAst),
	    _react2.default.createElement(_gatsbyImage2.default, { sizes: computerScienceNerdzLogo.sizes,
	      alt: "Do you like PapersWeLove? Stay tuned! ;)",
	      title: "Do you like PapersWeLove? Stay tuned! ;)" })
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-computer-science-nerdz-js-07369dcf2b419092fece.js